import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useAlert from 'hooks/use-alert';

const useUnauthorized = () => {
  const location = useLocation();
  const [unauthorized, setUnauthorized] = useState(false);
  const { closeAlert } = useAlert();

  useEffect(() => {
    const unauthorizedEventHandler = () => {
      closeAlert();
      setUnauthorized(true);
    };

    window.addEventListener('unauthorized', unauthorizedEventHandler);

    return () => {
      window.removeEventListener('unauthorized', unauthorizedEventHandler);
    };
  }, []);

  useEffect(() => {
    setUnauthorized(false);
  }, [location.pathname]);

  return { unauthorized };
};

export default useUnauthorized;
